import { createContext, useState, ReactNode } from 'react';
import { ProjectNode } from 'types/project';

type CurrentProjectContextValue = {
  currentProject: ProjectNode | null;
  setCurrentProject: (project: ProjectNode | null) => void;
};

type CurrentProjectContextProviderProps = {
  children?: ReactNode;
};

export const CurrentProjectContext = createContext<CurrentProjectContextValue>({
  currentProject: null,
  setCurrentProject: () => undefined,
});

const CurrentProjectContextProvider: React.FC<CurrentProjectContextProviderProps> = ({ children }) => {
  const [currentProject, setCurrentProject] = useState<ProjectNode | null>(null);

  return (
    <CurrentProjectContext.Provider
      value={{
        currentProject,
        setCurrentProject,
      }}
    >
      {children}
    </CurrentProjectContext.Provider>
  );
};

export default CurrentProjectContextProvider;
